import { reformatLabelForId } from 'modules/placements/utils';
import { ToggleField } from 'lib/iterable-hook-form';
import { Caption } from 'ui/theme';
import { TOGGLE_SIZES } from 'ui/toggle';
import { StyledFormField } from '../styles';

export type ToggleFormFieldProps = {
  name: string;
  helpText?: string;
  labelText: string;
};

export const ToggleFormField = ({ name, helpText, labelText }: ToggleFormFieldProps) => {
  return (
    <StyledFormField data-test="toggle-form-field" labelText={labelText} isHorizontalLayout>
      <ToggleField
        size={TOGGLE_SIZES.LARGE}
        name={name}
        id={reformatLabelForId(labelText)}
        showCheckmarkOnActive
      />
      <Caption data-test="toggle-form-field-help-text">{helpText}</Caption>
    </StyledFormField>
  );
};
